import React, {Component} from 'react'
import {Alert} from "react-bootstrap";

class DisplayItemUrlSettings extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return  <div>
                    <h3>{this.props.kedo.t('Settings')}</h3>
                    <Alert variant={"info"}>{this.props.kedo.t('No settings available')}</Alert>
                </div>
    }
}

export default DisplayItemUrlSettings